import { amplitudeKeyInternal, amplitudeKeyOldInternal, amplitudeKeyOldProd, amplitudeKeyProd, appTimestamp, appVersion, arcgisApiKeyDev, autodeskApiUrl, commitId, commitUrl, intercomAppIdDev, isNumberedEnv, jiraTicketId, jiraTicketUrl, localizeKey, muiProKey, numberedEnv, procoreApiUrlStaging, pullRequestId, pullRequestUrl, sentryDSNKey } from "@src/runtime-config-base";
export const runtimeConfig = {
  environment: "dev",
  appRegion: "com",
  appEnv: "com-dev",
  urls: {
    apiBaseUrl: "https://core.api.dev.holobuilder.com",
    analyticsBaseUrl: "https://hb-analytics-data-api-com-dev.azurewebsites.net/api",
    sphereViewerUrl: "https://viewer.dev.holobuilder.com",
    sphereVaultUrl: "https://vault.dev.holobuilder.com",
    dashboard20Api: "https://sphere.dev.holobuilder.com/api",
    hbWebEditorUrl: "https://app.dev.holobuilder.com",
    progressApiUrl: "https://progress.api.dev.holobuilder.com",
    sphereEntryPageUrl: numberedEnv === "dev1" ? "https://dev1.entry.dev.holobuilder.com" : "https://entry.dev.holobuilder.com",
    adminPanelUrl: "https://admin.dev.holobuilder.com",
    cookieManagerUrl: "https://cookies.dev.holobuilder.com/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-com-dev.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.dev.holobuilder.com",
    hbDashboardUrl: "https://dashboard.dev.holobuilder.com",
    uploadFrontDoorUrl: "https://uploads.dev.holobuilder.com",
    uploadStorageUrl: "https://holobuildercomdev.blob.core.windows.net",
    activityApiUrl: "https://activity.api.dev.holobuilder.com"
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.dev.farosphere.com",
      clientId: "wSsYe8Ye5nQ0jfTxs0Urxrqy9evj6W2u"
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdDev,
    arcgisApiKey: arcgisApiKeyDev
  },
  integrations: {
    procoreApiUrl: procoreApiUrlStaging,
    autodeskApiUrl
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv
};